import {
  calcCartTotal,
  applySelectedUnitToDisplay,
  parseAmount,
} from "./productUnitHelpers";

const draftKey = (shopId) => `visitorShopDraft_${shopId}`;

export const loadDraftCart = (shopId) => {
  if (!shopId) {
    return null;
  }
  try {
    const raw = localStorage.getItem(draftKey(shopId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearDraftCart = (shopId) => {
  if (!shopId) {
    return;
  }
  localStorage.removeItem(draftKey(shopId));
};

export const saveDraftCart = (shopId, productList) => {
  if (!shopId) {
    return;
  }

  const items = {};
  productList.forEach((product) => {
    const unitCounts = Object.entries(product.unitCounts || {}).reduce(
      (acc, [level, count]) => {
        if (Number(count) > 0) {
          acc[level] = Number(count);
        }
        return acc;
      },
      {}
    );

    if (Object.keys(unitCounts).length > 0) {
      items[product.id] = {
        unitCounts,
        selectedUnitLevel: product.selectedUnitLevel,
      };
    }
  });

  if (Object.keys(items).length === 0) {
    localStorage.removeItem(draftKey(shopId));
    return;
  }

  localStorage.setItem(
    draftKey(shopId),
    JSON.stringify({
      items,
      total: calcCartTotal(productList),
      updatedAt: Date.now(),
    })
  );
};

export const mergeDraftIntoProducts = (products, draft) => {
  if (!draft?.items) {
    return products;
  }

  return products.map((product) => {
    const saved = draft.items[product.id];
    if (!saved) {
      return product;
    }

    const unitCounts = { ...product.unitCounts, ...saved.unitCounts };

    return applySelectedUnitToDisplay({
      ...product,
      unitCounts,
      selectedUnitLevel: saved.selectedUnitLevel ?? product.selectedUnitLevel,
    });
  });
};

export const resolveOrderTotal = (baseNewOrderTotal, productList) => {
  const base = parseAmount(baseNewOrderTotal);
  const cart = calcCartTotal(productList);
  return base + cart;
};

export const applyShopCartUpdate = (shopId, productList, baseNewOrderTotal = 0) => {
  saveDraftCart(shopId, productList);
  return resolveOrderTotal(baseNewOrderTotal, productList);
};
